import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { buildDataAttributes } from "../buildDataAttributes.mjs";
import { MaxLines } from "../MaxLines/MaxLines.mjs";
import { alignToFlexAlign } from "../../../utils/align.mjs";
import { descenderCropFixForWebkitBox } from "../MaxLines/MaxLines.css.mjs";
import { iconSlotSpace } from "../iconSlotSpace.mjs";
const Typography = ({
  id,
  component = "span",
  className,
  align,
  maxLines,
  icon,
  data,
  children,
  ...restProps
}) => {
  const isTruncated = typeof maxLines === "number";
  const contents = isTruncated ? /* @__PURE__ */ jsx(MaxLines, { lines: maxLines, children }) : children;
  return /* @__PURE__ */ jsx(
    Box,
    {
      id,
      display: "block",
      component,
      textAlign: align,
      className: [
        className,
        isTruncated ? descenderCropFixForWebkitBox : void 0
      ],
      minWidth: isTruncated ? 0 : void 0,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: icon ? /* @__PURE__ */ jsxs(
        Box,
        {
          component: "span",
          display: "flex",
          justifyContent: alignToFlexAlign(align),
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                component: "span",
                display: "block",
                paddingRight: iconSlotSpace,
                flexGrow: 0,
                flexShrink: 0,
                minWidth: 0,
                textAlign: align,
                children: icon
              }
            ),
            /* @__PURE__ */ jsx(Box, { component: "span", display: "block", minWidth: 0, children: contents })
          ]
        }
      ) : contents
    }
  );
};
export {
  Typography
};
